module.exports = __webpack_public_path__ + "images/花筑般蓝pr长图10-2.jpg?v=dd90f63f";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu3/花筑般蓝pr长图10-2.jpg
 ** module id = 55
 ** module chunks = 1 2
 **/